// extracted by mini-css-extract-plugin
module.exports = {"form":"complete-data-form_form__BvdDu"};